import { captureRemixErrorBoundaryError } from '@sentry/remix'
import {
  LoaderFunctionArgs,
  LinksFunction,
  Links,
  Meta,
  Outlet,
  Scripts,
  ScrollRestoration,
  useRouteLoaderData,
  useRouteError,
} from 'react-router'
import ReactGA from 'react-ga4'

import { getCityFromSession, getUserFromSession } from './data/auth.server'

import Navbar from './components/Navbar'
import Footer from './components/Footer'

import './tailwind.css'
import './global.css'

export const loader = async ({ request }: LoaderFunctionArgs) => ({
  user: await getUserFromSession(request.headers.get('Cookie')),
  city: await getCityFromSession(request.headers.get('Cookie')),
})

export const Layout = ({ children }: { children: React.ReactNode }) => {
  const data = useRouteLoaderData<typeof loader>('root')

  return (
    <html lang='en'>
      <head>
        <meta charSet='utf-8' />
        <meta name='viewport' content='width=device-width, initial-scale=1' />
        <Meta />
        <Links />
      </head>
      <body>
        <Navbar user={data?.user} city={data?.city} />
        <div className='mx-6 md:mx-16'>
          {children}
          <Footer user={data?.user} />
        </div>
        <ScrollRestoration />
        <Scripts />
      </body>
    </html>
  )
}

export const links: LinksFunction = () => [
  {
    rel: 'preconnect',
    href: 'https://fonts.googleapis.com',
  },
  {
    rel: 'preconnect',
    href: 'https://fonts.gstatic.com',
  },
  {
    rel: 'stylesheet',
    href: 'https://fonts.googleapis.com/css2?family=DM+Sans:ital,opsz,wght@0,9..40,100..1000;1,9..40,100..1000&display=swap',
  },
  {
    rel: 'stylesheet',
    href: 'https://fonts.googleapis.com/css2?family=DM+Mono:ital,wght@0,300;0,400;0,500;1,300;1,400;1,500&display=swap',
  },
  {
    rel: 'icon',
    href: '/favicon.ico',
  },
]

const App = () => {
  typeof window !== 'undefined' && ReactGA.initialize('G-X1TQK3M04L')
  return <Outlet />
}

export const ErrorBoundary = () => {
  const isProd = process.env.NODE_ENV === 'production'
  const error = useRouteError()
  isProd && captureRemixErrorBoundaryError(error)

  return (
    <div>
      <p>Something went wrong</p>
      <a className='text-blue underline' href='/'>Home Page</a>
    </div>
  )
}

export default App
